import React, { useEffect } from 'react'
import { codeFromClipboard } from './use-device-code'

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', null, '0', 'back']

// 3-col numberpad. Both the on-screen keys and a window keydown listener dispatch
// through the same onDigit / onBackspace handlers (unified input path).
export const Numberpad = ({ onDigit, onBackspace, disabled, codeLength }) => {
  useEffect(() => {
    if (disabled) return
    const handler = e => {
      if (/^[0-9]$/.test(e.key)) onDigit(e.key)
      else if (e.key === 'Backspace' || e.key === 'Delete') onBackspace()
    }
    // Cmd+V a code copied from the other device.
    //
    // This used to take the first CODE_LENGTH_MAX digits and leave the reducer to
    // cap them, on the reasoning that the keypad should not need to know the
    // current length. The reducer does cap — but capping is all it can do. Eight
    // digits became a silent auto-submit of the first six, and four digits filled
    // four of six wells and stopped dead with nothing to tell the user, which is
    // indistinguishable from the modal being broken.
    //
    // So the length comes in as a prop and the paste has to match it exactly.
    const onPaste = e => {
      const text = (e.clipboardData && e.clipboardData.getData('text')) || ''
      const digits = codeFromClipboard(text, codeLength)
      if (digits) {
        e.preventDefault()
        digits.split('').forEach(d => onDigit(d))
      }
    }
    window.addEventListener('keydown', handler)
    window.addEventListener('paste', onPaste)
    return () => {
      window.removeEventListener('keydown', handler)
      window.removeEventListener('paste', onPaste)
    }
  }, [onDigit, onBackspace, disabled, codeLength])

  return (
    <div className="ld-numpad">
      {KEYS.map((k, i) => {
        if (k === null) return <div key={i} className="ld-key ld-key--blank" aria-hidden="true" />
        if (k === 'back') {
          return (
            <button key={i} type="button" className="ld-key ld-key--back" onClick={onBackspace} disabled={disabled} aria-label="backspace">
              ⌫
            </button>
          )
        }
        return (
          <button key={i} type="button" className="ld-key" onClick={() => onDigit(k)} disabled={disabled}>
            {k}
          </button>
        )
      })}
    </div>
  )
}
